export default __webpack_public_path__ + "static/media/HPLogo.4797279d.png";